import { Type } from 'bukku/redux/Transaction/helper';

export const getShowMyInvoisActionButton = (
    isMalaysianCompany: boolean,
    transactionType: keyof typeof Type,
    transactionStatus: string,
    isRecurring: boolean,
) => isMalaysianCompany &&
    [
        Type.sale_invoice, Type.sale_credit_note,
        Type.purchase_bill, Type.purchase_credit_note,
    ].includes(transactionType)
    && (
        (
            (!isRecurring && ['ready', 'void'].includes(transactionStatus)) ||
            (isRecurring && transactionStatus === 'ready')
        )
    );
